import React from 'react';
import { SalesPage } from './pages/SalesPage';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <SalesPage data-id="element-0" />;
}